import layout from './layout'

export default {
    layout,
}